import { IActivityResponse } from './types';
import { getApi } from '../apiClient';

export async function getActivity(params: {
  startDate?: string;
  endDate?: string;
}): Promise<IActivityResponse> {
  const { startDate, endDate } = params;
  const { data } = await getApi().get<IActivityResponse>('/profile/activities', {
    params: {
      ...(startDate && { start_date: startDate }),
      ...(endDate && { end_date: endDate })
    }
  });

  return data;
}
